import { Middleware, configureStore } from '@reduxjs/toolkit'
import { onlyForDev } from '@/utils/check-environment'
import { hotelFacilityReducer } from './hotel-facility/hotel-facility-slice'
import { reportManagerReducer } from './report-manager/report-manager-slice'
import { editingSectionReducer } from './reservation-detail/editing-section-slice'
import { operationLogReducer } from './operation-log/operation-log-slice'
import { restaurantManagerReducer } from './restaurant-manager/restaurant-manager-slice'

const throwMiddleware: Middleware = () => next => action => {
  const act = next(action) as any
  if (act?.error?.name === 'ConditionError') {
    delete act['error']
    return act
  }
  return act
}

export const store = configureStore({
  reducer: {
    hotelFacility: hotelFacilityReducer,
    reportManager: reportManagerReducer,
    editingSection: editingSectionReducer,
    operationLog: operationLogReducer,
    restaurantManager: restaurantManagerReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(throwMiddleware),
  devTools: onlyForDev,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
